import { createFileRoute, notFound } from "@tanstack/react-router";
import { getLocation, locationSlugs } from "@/lib/locations";
import { LocationPage } from "@/components/LocationPage";
import { OG_IMAGE, absolute, hreflangLinks } from "@/lib/site";
import { graph, serviceSchema, faqPage, breadcrumbList } from "@/lib/schema";

export const Route = createFileRoute("/services/iso-certification/$city")({
  beforeLoad: ({ params }) => {
    if (!locationSlugs.includes(params.city)) throw notFound();
  },
  head: ({ params }) => {
    const l = getLocation(params.city);
    if (!l || !locationSlugs.includes(params.city)) return {};
    const path = `/services/iso-certification/${l.slug}`;
    const url = absolute(path);
    return {
      meta: [
        { title: l.metaTitle.en },
        { name: "description", content: l.description.en },
        { property: "og:title", content: l.metaTitle.en },
        { property: "og:description", content: l.description.en },
        { property: "og:type", content: "article" },
        { property: "og:url", content: url },
        { property: "og:image", content: OG_IMAGE },
        { name: "twitter:image", content: OG_IMAGE },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks(path)],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            graph(
              serviceSchema({
                path,
                name: l.title.en,
                serviceType: l.serviceType?.en ?? `ISO certification in ${l.city.en}`,
                description: l.description.en,
                areaServed: l.areaServed,
              }),
              faqPage(
                path,
                l.faq.map((f) => ({ q: f.q.en, a: f.a.en })),
              ),
              breadcrumbList([
                { name: "Home", path: "/" },
                { name: "Services", path: "/services" },
                { name: l.title.en, path },
              ]),
            ),
          ),
        },
      ],
    };
  },
  component: LocationRoutePage,
});

function LocationRoutePage() {
  const { city } = Route.useParams();
  const l = getLocation(city);
  if (!l || !locationSlugs.includes(city)) throw notFound();
  return <LocationPage location={l} />;
}
